import React, { createContext, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import NavBar from "./pages/NavBarPage";
import { Footer } from "./pages/FooterPage";
import UnauthorizedMessage from './components/auth/UnauthorizedMessage';
import { AuthCheck } from './components/auth/AuthCheck';
import ChatVersionWrapper from './pages/ChatVersionWrapper';
import RedirectPage from './pages/RedirectPage';
// import Dashboard from './pages/Dashboard';
import './App.css';
interface RoleFunctionality {
  Functionality: string;
  Role: string;
  ScreenName: string;
}
interface AuthContextType {
  roleFunctionalities: RoleFunctionality[];
}

// const AuthContext = createContext<AuthContextType | undefined>(undefined);
// // Hook to check for specific functionality
// const useHasFunctionality = (functionality: string) => {
//   const context = useContext(AuthContext);
//   if (!context) throw new Error('useHasFunctionality must be used within AuthContext');
  
//   return context.roleFunctionalities.some(
//     rf => rf.Functionality === functionality
//   );
// };

// Protected content component
const ProtectedContent = ({ children }: { children: React.ReactNode }) => {
  // const hasHomeScreen = useHasFunctionality('HomeScreen');

  // if (!hasHomeScreen) {
  //   return <UnauthorizedMessage />;
  // }

  return (
    <div>
      <div id="wrapper">
        {/* <NavBar /> */}
        <main className="w-full ">
          {children}
        </main>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

function App() {
  return (
    // <AuthCheck>
          <Router> {/* Wrap everything inside Router */}
            <Routes>
              {/* Define route for Virtual Assistants List */}  
              <Route path="/:app_id" element={<ProtectedContent><ChatVersionWrapper /></ProtectedContent>} />
              <Route path="/authredirect" element={<ProtectedContent><RedirectPage /></ProtectedContent>} />
              {/* <Route path="/dashboard" element={<Dashboard />} /> */}
              {/* Define route for Build New Assistant */}
            </Routes>
          </Router>
    // </AuthCheck>
  );
}

export default App;
